/**
 * BatchGeoGoogleMapsMarker is an API to manage everything related to markers on a map.
 * It has a few plugins that change the behavior of markers such as grouping them into
 * clusters, creating the content for each marker, build the infowindow for every marker
 * and generating the legend for these markers.
 */
(function (window) {
  function BatchGeoGoogleMapsMarker(options) {
    options = options || {};
    this.options = $.extend(
      {
        markersData: options.markersData || {}, //this is the global 'per' variable from bg.maps.js
        distance_str: "Distance",
        markerHeights: {
          pushpin: 34,
          circle: 20,
          square: 24,
          measureDistancePin: 48,
        }, // marker heights. Pending removal of this var from bg.maps.js
        baseURL: "",
        thematicColors: [
          "red",
          "orange",
          "yellow",
          "green",
          "paleblue",
          "blue",
          "purple",
        ],
        heatColors: ["darkgreen", "green", "yellow", "orange", "red"],
        plugins: [
          window.MarkerGroups,
          window.MarkerDrawer,
          window.MarkerContent,
          window.MarkerLegend,
          window.MarkerInfoWindow,
          window.MarkerResizer,
        ],
      },
      options,
    );
    this.options.markersData.colors =
      this.options.markersData.colors || window.colorPallet.slice(0);
    if (window.per) {
      // Initialize `window.per.colors` and `window.hex`
      if (window.per.colors.length == 0) {
        window.per.colors = this.options.markersData.colors;
      }

      while (window.per.colors.length < 10) {
        window.per.colors.push(window.colorPallet[window.per.colors.length]);
      }

      this._synchronizeColorAndHexArray(window.per.colors, "hex");

      // Initialize `window.per.thematicColors` and `window.thematicHexArray`
      if (!window.per.thematicColors) {
        window.per.thematicColors = this.options.thematicColors;
      }
      this._synchronizeColorAndHexArray(
        window.per.thematicColors,
        "thematicHexArray",
      );
    }
    this._initializeMarkers();
    return this;
  }

  /**
   * _synchronizeColorAndHexArray
   *
   * @param {Array<String>} sourceColorArray The source color array, commonly `window.per.colors` or `window.per.thematicColors`.
   * @param {String} hexArrayKey The key to access the sourceColorArray's corresponing hexArray on the window object.
   * @returns {void}
   */
  BatchGeoGoogleMapsMarker.prototype._synchronizeColorAndHexArray = function (
    sourceColorArray,
    hexArrayKey,
  ) {
    // If hex array is undefined, initialize it.
    if (!window[hexArrayKey]) {
      window[hexArrayKey] = [];
    }

    // loop color array and update the corresponding hexArray
    for (let i = 0; i < sourceColorArray.length; i++) {
      // take color at index x in the provided colors
      let color = sourceColorArray[i];

      // find index of color in ground truth colorPallet
      let colorIndex = window.colorPallet.indexOf(color);

      // find corresponding hex value for colorIndex
      let colorHex = window.hexArray[colorIndex];

      window[hexArrayKey][i] = colorHex;
    }
  };

  BatchGeoGoogleMapsMarker.prototype._initializeMarkers = function () {
    this.lastMarker = null;
    this._loadPlugins();
    return this;
  };

  //load all the plugins that help building markers
  BatchGeoGoogleMapsMarker.prototype._loadPlugins = function () {
    var self = this;
    if (!this.options.plugins) return;

    this.options.plugins.forEach(function (plugin) {
      plugin.call(self);
    });
  };

  BatchGeoGoogleMapsMarker.prototype.getMarkerCount = function () {
    return this.MarkerDrawer.getMarkerCount();
  };
  /**
   * This returns an array of markers that are visible. For example, if you have
   * 100 markers and you have a filter that hide all but 5 markers, this will
   * return the 5 markers. (If you need to get *all* markers use the
   * getMarkersObjArray method).
   *
   * This is what the old `mrks` global used to represent.
   *
   * @return {Array} A collection/array of visible markers
   */
  BatchGeoGoogleMapsMarker.prototype.getMarkers = function () {
    return this.MarkerDrawer.getMarkers();
  };

  /**
   * Returns all markers in an object with the marker IDs as the key name. The
   * result would look like {0: Marker, 5: Marker, ...}
   *
   * @return {object}
   */
  BatchGeoGoogleMapsMarker.prototype.getMarkersAsObject = function () {
    var markerObject = {};

    this.getMarkers().forEach(function (marker) {
      markerObject[marker.r] = marker;
    });

    return markerObject;
  };

  /**
   * This.getMarkersObjArray() used to be `markers` global variable in
   * bg.maps.js. It's a complete markers dataset, index matches per.mapRS rows.
   * The difference between this and getMarkers() is that this is a plain JS
   * object with additional information including the marker object as one of
   * its properties. In other words:
   * getMarkers()[0] == this.getMarkersObjArray()[0].marker
   *
   * NOTE: Although this returns an array the length of the complete marker set
   * it will NOT always contain all markers. If you have 5 markers and set a
   * filter that hides the first 2 markers your array will look like:
   * [null, null, marker3, marker4, marker5]
   *
   * @return {array}
   */
  BatchGeoGoogleMapsMarker.prototype.getMarkersObjArray = function () {
    return this.MarkerDrawer.getMarkersObjArray();
  };

  BatchGeoGoogleMapsMarker.prototype.clearMarkersObjArray = function () {
    return this.MarkerDrawer.clearMarkersObjArray();
  };

  BatchGeoGoogleMapsMarker.prototype.getMarkerGroupsArray = function () {
    return this.MarkerGroups.getGroupsArray();
  };

  /**
   * Finds a given marker by ID in the marker collection
   * @param {number} id The ID of the marker to do a lookup on
   * @return {null|object} Will return the marker object if found or null if not
   */
  BatchGeoGoogleMapsMarker.prototype.getMarker = function (id) {
    var marker = this.getMarkers().filter(function (marker) {
      return marker.r === id;
    })[0];

    // If a marker was found return it, otherwise return null
    return marker ? marker : null;
  };
  /*
   * Use this property to open a marker from anywhere in the app.
   * It expects a marker.
   * @returns nothing.
   */
  BatchGeoGoogleMapsMarker.prototype.openMarker = function (marker) {
    if (marker == undefined || marker == null) return;
    window.scrollTo(0, 0);
    this.MarkerInfoWindow.open(marker);
  };

  /*
   * Use this property to close a marker from anywhere in the app.
   * If there is no open marker it will do nothing.
   * @returns nothing.
   */
  BatchGeoGoogleMapsMarker.prototype.closeMarker = function () {
    this.MarkerInfoWindow.close();
  };

  BatchGeoGoogleMapsMarker.prototype.removeMarker = function () {
    var self = this;
    var marker = BatchGeoStore.getState().MapsMarkersManager.lastOpenedMarker;
    return BatchGeo.customConfirm(
      "Are you sure you want to remove this location?\n\n" +
        this.options.markersData.mapRS[marker.r].addr,
      function () {
        self.options.markersData.mapRS.splice(marker.r, 1);
        self.options.markersData.dataRS.splice(marker.r, 1);
        BatchGeoStore.dispatch({ type: "MARKER_DRAWER_ENABLE_DRAWING" });
        self.MarkerDrawer.draw();
        marker.setMap(null);
      },
    );
  };

  /**
   * Looks at the global "mrks" variable which is an array of markers and zooms
   * the map to fit the markers within the map window.
   *
   * @return {undefined}
   */
  BatchGeoGoogleMapsMarker.prototype.zoomToMarkers = function () {
    var markers = this.getMarkers();
    var row = markers.length;

    var map = window.batchGeoGoogleMapsManager.getMap();

    window.bounds = new google.maps.LatLngBounds();

    // As we loop through the markers get the lat/lng of the marker and extend the
    // boundaries of the map until it fits all the markers in the collection
    for (var i = 0; i < row; i++) {
      window.bounds.extend(markers[i].position);
    }

    const boundsCenter = window.bounds.getCenter();
    if (boundsCenter.lat() !== 0 || boundsCenter.lng() !== -180) {
      // if marker generated bounds has valid lat/lng
      // fit map bounds and set map center to match generated bounds
      map.fitBounds(window.bounds);
      map.setCenter(boundsCenter);
    }

    // if markers.length is only 1 we just open that marker
    if (row === 1) {
      this.MarkerInfoWindow.smoothOpenMarker(markers[0].r);
    }

    return this;
  };

  window.BatchGeoGoogleMapsMarker = BatchGeoGoogleMapsMarker;
})(window);
